import { render, staticRenderFns } from "./CodeViewer.vue?vue&type=template&id=401ae59d&scoped=true"
import script from "./CodeViewer.vue?vue&type=script&lang=js"
export * from "./CodeViewer.vue?vue&type=script&lang=js"
import style0 from "./CodeViewer.vue?vue&type=style&index=0&id=401ae59d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ae59d",
  null
  
)

export default component.exports